import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const SimpleFooterBase = styled.footer`
  width: 80%;
  display: flex;
  flex-direction: column;
  padding: 32px 10%;

  ${theme.largerThan.md} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const FooterCopyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${theme.largerThan.md} {
    flex-direction: row;
  }
`;

export const FooterCopy = styled.div`
  color: #476175;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  margin-bottom: 8px;

  ${theme.largerThan.md} {
    line-height: 34px;
    padding: 0 16px;
    white-space: nowrap;

    &:first-of-type {
      border-right: 1px solid #979797;
    }
  }
`;
